import React from 'react';
import { useSelector } from 'react-redux';
import { Layout } from 'antd';
import { Route, Routes } from 'react-router-dom';
import SidebarComponent from './sidebar';
import UserManager from '../UserManager';
import './index.less';
import UserDetails from '../UserManager/userDetails';
import TenantManager from '../TenantManager';
import TenantDetail from '../TenantManager/detail';
import TenantUserDetail from '../TenantManager/detail/UserManager/userDetails';
import PushSettings from '../PushSettings';

const LayoutComponent = () => {
  const { Content } = Layout;
  const user = useSelector((state) => state.authReducer?.user);

  return (
    <Layout className='most-parent-layout'>
      <Layout className='site-layout'>
        <SidebarComponent />
        <Content className='layout-content site-layout-background custom-textarea'>
          <Routes>
            {user?.roles?.includes('super_admin') && (
              <>
                <Route path='/users-manager' element={<UserManager />} />
                <Route
                  path='/users-manager/update/:id'
                  element={<UserDetails />}
                />
                <>
                  <Route
                    path='/users-manager/create'
                    element={<UserDetails />}
                  />
                </>
              </>
            )}

            {user?.roles?.includes('super_admin') && (
              <>
                {/* <Route path='tenant-management' element={<TenantManager />}>
                  <Route path='create' element={<TenantDetail />} />
                  <Route path='update/:id' element={<TenantDetail />}>
                    <Route path='user/create' element={<TenantUserDetail />} />
                    <Route
                      path='user/update/:tenantUserId'
                      element={<TenantUserDetail />}
                    />
                  </Route>
                </Route> */}
                <Route
                  path='/institute-management'
                  element={<TenantManager />}
                ></Route>
                <Route
                  path='/institute-management/create'
                  element={<TenantDetail />}
                />
                <Route
                  path='/institute-management/update/:id'
                  element={<TenantDetail />}
                ></Route>
                <Route
                  path='/institute-management/update/:id/user/create'
                  element={<TenantUserDetail />}
                />
                <Route
                  path='/institute-management/update/:id/user/update/:tenantUserId'
                  element={<TenantUserDetail />}
                />
                <Route path='/push-notifications' element={<PushSettings />} />
              </>
            )}

            <Route path='/profile' element={<UserDetails />} />
          </Routes>
        </Content>
      </Layout>
    </Layout>
  );
};

export default LayoutComponent;
